import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Navigation(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M22.707 1.293a1 1 0 0 1 .197 1.135l-9 19a1 1 0 0 1-1.874-.185l-1.855-7.418-7.418-1.855a1 1 0 0 1-.185-1.874l19-9a1 1 0 0 1 1.135.197ZM5.953 10.708l5.29 1.322a1 1 0 0 1 .727.728l1.322 5.289 6.606-13.945-13.945 6.606Z" }) }));
}
